import { useState, useEffect } from "react";
import apiClient from "../utils/apiClient";
import { useNavigate, Link } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";
import { useAuth } from "../contexts/authContext";
import { useSubscription } from "../contexts/SubscriptionContext";
import { Purchases } from "@revenuecat/purchases-capacitor";
import { Purchases as PurchasesWeb } from "@revenuecat/purchases-js";
import { toast } from "react-toastify";

export default function Login() {
  const { login } = useAuth();
  const { setIsSubscribed } = useSubscription();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [keyboardOffset, setKeyboardOffset] = useState(0);
  const navigate = useNavigate();

  // Keyboard handling for Android
  useEffect(() => {
    if (Capacitor.getPlatform() === "android") {
      const showSub = Keyboard.addListener("keyboardWillShow", (info) => {
        setKeyboardOffset(info.keyboardHeight || 300);
      });
      const hideSub = Keyboard.addListener("keyboardWillHide", () => {
        setKeyboardOffset(0);
      });
      return () => {
        showSub.remove();
        hideSub.remove();
      };
    }
  }, []);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      // 1) Log in to backend
      const res = await apiClient.post("/auth/login", form);
      login(res.data.token, res.data.user._id);

      
      // 2) Fetch RevenueCat customerInfo (native vs. web)
      let customerInfo = null;

      if (Capacitor.isNativePlatform()) {
        try {
          await Purchases.logIn({ appUserID: res.data.user._id });
          const { customerInfo: info } = await Purchases.getCustomerInfo({
            fetchPolicy: "FETCH_CURRENT",
          });
          customerInfo = info;
          
        } catch (err) {
          console.error("⚠️ Native getCustomerInfo failed", err);
          // Provide a safe fallback so we don’t blow up downstream
          customerInfo = { entitlements: { active: {}, all: {} } };
        }

      } else {
        try {
          await PurchasesWeb.getSharedInstance().changeUser(res.data.user._id);
          customerInfo = await PurchasesWeb.getSharedInstance().getCustomerInfo();

        } catch (err) {
          console.error("⚠️ Web getCustomerInfo failed", err);
          customerInfo = { entitlements: { active: {}, all: {} } };
        }
      }

      // 3) Decide subscription state
      const isActive = !!customerInfo.entitlements?.active?.["sous_premium"];
      //apiClient.post('/subscriptions/update', { active: isActive }).catch((e) => console.error('update failed', e));
      //const isActive = res.data.user.isSubscribed;
      console.log(res.data.user._id + " Subscribed:" + isActive);
      setIsSubscribed(isActive);

      navigate("/"); // Go to home for all users.
      /*
      // 4) Navigate based on subscription
      if (isActive) {
        navigate("/chat");
      } else {
        navigate("/subscribe");
      }
      */
    } catch (err) {
      console.error("Login or subscription check failed:", {err});
      const msg = err.response?.data?.message || "Login failed.";
      setError(msg);
    }
  };

  return (
    <div
      className="min-h-screen bg-cover bg-center flex flex-col text-center font-sans" //min-h-[calc(100vh-60px)]
      style={{ backgroundImage: "url('assets/splash-2.png')" }}
    >
      <h1 className="text-5xl font-light tracking-tight text-[#1F2937] pt-8 pb-4">
        Sous
      </h1>

      <div
        className="flex-1 flex items-center justify-center overflow-y-auto px-4 py-8"
        style={{ paddingBottom: `${keyboardOffset}px` }}
      >
        <div className="bg-white backdrop-blur-sm rounded-xl md:rounded-xl p-4 m-4 max-w-xl w-full space-y-6 shadow-lg">
          <h2 className="text-xl font-semibold">Login</h2>
          <form onSubmit={handleSubmit} className="max-w-sm mx-auto mt-10 space-y-4">
            {error && <p className="text-red-500 text-sm">{error}</p>}
            <input
              className="w-full p-2 border"
              type="email"
              name="email"
              placeholder="Email"
              inputMode="email"
              autoComplete="email"
              onChange={handleChange}
            />
            <input
              className="w-full p-2 border"
              type="password"
              name="password"
              placeholder="Password"
              autoComplete="current-password"
              onChange={handleChange}
            />
            <button className="w-full bg-charcoal text-white p-2 rounded-3xl hover:bg-charcoal/80">Login</button>
            <p className="w-full text-right">
              <Link to="/forgot-password" className="text-sm italic">
                I’ve forgotten my password
              </Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
